<!--
	Enables the incremental-hydration runtime at bootstrap; without it no
	`hydrate on ...` trigger in this app ever arms. See the "Incremental
	hydration" gotcha in CLAUDE.md before removing.
-->
@defer (hydrate never) {
	<span hidden></span>
}

<main role="main">
	<sb-wrapper>
		<router-outlet />
	</sb-wrapper>
</main>
